import React, { FunctionComponent } from 'react';
import { FormattedMessage } from 'react-intl';
import { getSortingValues } from '../../common/helpers/filterHelper';
import SearchInput from '../SearchInput';
import styles from './styles.module.scss';
import { SortType } from '../../common/enums/SortType';
import { IDateFilter } from '../../common/models/filter/IDateFilter';
import DateRange from '../DateRange';
import { IBindingAction, IBindingCallback1 } from '../../common/models/callback';
import FavoritesFilter from '../FavoritesFilter';
import { FavoritesFilterOption } from '../../common/enums/FavoritesFilterOption';
import Icon from '../Icon';

interface IProps {
  sortType: SortType;
  filterValue: string | IDateFilter | FavoritesFilterOption;
  onSort: IBindingAction;
  onFilter: IBindingCallback1<string | IDateFilter | FavoritesFilterOption>;
}

const TableFilter: FunctionComponent<IProps> = ({ sortType, onSort, onFilter, filterValue }) => {
  const getFilter = () => {
    switch (sortType) {
      case SortType.Date:
        const { from, to } = filterValue as IDateFilter;
        return (
          <DateRange
            from={from}
            to={to}
            onChangeFrom={date => onFilter({ to, from: date as Date })}
            onChangeTo={date => onFilter({ from, to: date as Date })}
          />
        );
      case SortType.Favorites:
        return <FavoritesFilter onFilter={onFilter} value={filterValue as FavoritesFilterOption} />;
      default:
        return <SearchInput value={filterValue as string} width="100%" onChange={onFilter} />;
    }
  };

  return (
    <div>
      <div className={styles.tableSorting} role="presentation" onClick={onSort}>
        <div className={styles.sortingIcons}>
          <Icon className={styles.sortAsc} icon="sort" />
          <Icon icon="sort" />
        </div>
        <FormattedMessage id="sort" defaultMessage="Sort {from} to {to}" values={getSortingValues(sortType)} />
      </div>
      {getFilter()}
    </div>
  );
};

export default TableFilter;
